import React from 'react';

const cell = { padding:'6px 10px', borderBottom:'1px solid rgba(128,128,128,.25)',
               fontSize:13, verticalAlign:'top' };
const rs = v => 'Rs' + Math.round(v).toLocaleString('en-IN');
const lv = v => Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 });

function status(a) {
  const g = a.regime;
  if (a.open) {
    let t = `Holding #${a.open.id} ${a.open.structure} to ${a.open.expiry} · P&L ${rs(a.open.pnl)}`;
    if (g && g.stop) t += ` · exits on a close past ${lv(g.stop)}`;
    return t;
  }
  if (a.pending) return `Proposal #${a.pending.id} pending since ${a.pending.for_date} - approve or reject`;
  if (g && g.regime) {
    const w = g.regime === 'BULL' ? `a break above ${lv(g.signal_high)}`
            : g.regime === 'BEAR' ? `a break below ${lv(g.signal_low)}`
            : 'the day after the signal (condor)';
    return `${g.regime} signal candle ${g.signal_date} - waiting for ${w}`;
  }
  if (a.last_refusal) return `${a.last_refusal.date}: ${a.last_refusal.detail || a.last_refusal.reason}`;
  return 'Not evaluated yet - first run at 15:25';
}

export default function Arms({ list }) {
  if (!list || !list.length) return null;
  return (
    <div style={{ margin:'12px 0 20px' }}>
      <div style={{ fontWeight:600, fontSize:15, marginBottom:6 }}>Arms - what each strategy is doing</div>
      <div style={{ overflowX:'auto' }}>
        <table style={{ borderCollapse:'collapse', width:'100%' }}>
          <thead><tr>{['Strategy', 'Now', 'Closed trades', 'Closed P&L'].map(h =>
            <th key={h} style={{ ...cell, textAlign:'left', fontWeight:600, opacity:.7 }}>{h}</th>)}
          </tr></thead>
          <tbody>{list.map(a => (
            <tr key={a.id}>
              <td style={cell}>{a.name}</td>
              <td style={cell}>{status(a)}</td>
              <td style={cell}>{a.closed.n}{a.closed.n ? ` (${a.closed.wins} won)` : ''}</td>
              <td style={{ ...cell, color: a.closed.pnl > 0 ? '#1a8f4a'
                                         : a.closed.pnl < 0 ? '#c0392b' : 'inherit' }}>
                {a.closed.n ? rs(a.closed.pnl) : '-'}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
